import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch all pujas with filters
export const getPujas = async (params = {}) => {
  try {
    const response = await api.get(`${API_URL}/puja`, {
      params: params // Add this to send query parameters
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
    throw error; // Make sure to re-throw the error
  }
};

// Add a new puja
export const addPuja = async (puja) => {
  try {
    const response = await api.post(`${API_URL}/puja`, puja,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
    throw error;
  }
};

// Update a puja
export const updatePuja = async (id, puja) => {
  try {
    // console.log('puja dta a', puja)
    const response = await api.put(`${API_URL}/puja/${id}`, puja,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
    throw error;
  }
};

// Update an astrologer status
export const updatePujaStatus = async (id, updateStatusObj) => {
  try {
    const response = await api.put(`${API_URL}/puja/status/${id}`, updateStatusObj);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
    throw error;
  }
};


 
// Fetch puja reviews (GET api/admin/puja/reviews/:pujaId)
export const getPujaReviews = async ({ id, page = 1, limit = 10 }) => {
  try {
    const response = await api.get(
      `${API_URL}/puja/reviews/${id}?page=${page}&limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};
 
// Update puja review approval status (PUT api/admin/puja/reviews/approval/:reviewId)
// req.body --> approved: true | false
export const updatePujaReviewStatus = async (reviewId, approved) => {
  try {
    const response = await api.put(
      `${API_URL}/puja/reviews/approval/${reviewId}`,
      { approved },
    );
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};


// Delete a puja
export const deletePuja = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/puja/${id}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
    throw error;
  }
};